import { AuthenticatedLayout } from "../../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { ImportData } from "../../../../components/AddOns/Accounting/ImportData";

export const ImportDataPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Import Data"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      mainContents={<ImportData />}
    />
  );
};
